import { post } from '@/utils/request'

/**
 * 管理员查看采集清单 
 * @param {String}  asid	                     asid	 
 * @param {String}  item_salenum_from	         销量起始区间 
 * @param {String}  item_salenum_to	           销量终止区间 
 * @param {String}  max_commission_rate_from	 佣金起始区间 
 * @param {String}  max_commission_rate_to	   佣金终止区间 
 * @param {String}  add_time_from	             采集时间起始区间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2} 
 * @param {String}  add_time_to	               采集时间终止区间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2} 
 * @param {String}  item_iid	                 淘宝ID 
 * @param {String}  item_name	                 商品名称 
 * @param {String}  item_brand	               商品品牌 
 * @param {String}  from	                     来源: dataoke大淘客 smzdm什么值得买 baicaio 白菜哦 cqp 酷Q
 * @param {String}  item_taoqiangou	           是否淘抢购 0 否 1 是 
 * @param {String}  item_juhuasuan	           是否聚划算 0 否 1 是 
 * @param {String}  is_gold	                   是否金牌商家 0 否 1 是 
 * @param {String}  is_tmall	                 是否天猫商家 0 否 1 是 
 * @param {String}  item_freight_insurance	   是否天猫商家 0 否 1 是 
 * @param {String}  item_has_videos	           是否视频 0 否 1 是 
 * @param {String}  include_published	         是否包含已经发布的商品 默认是0 不包含 1表示包含 
 * @param {String}  order	                     排序方式 [add_time|item_salenum|max_commission_rate|hot] [ASC|DESC] 比如 add_time ASC注意中间有个空格 
 * @param {String}  page	                     页码 
 * @param {String}  pagesize	                 分页大小      
 */
export function admin_items_catch_list(data) {
  return post('admin_items_catch_list', data)
}

/**
 * 管理员发布采集内容(已经存在的商品无法导入) 
 * @param {String} asid	            asid	                
 * @param {String} id	              采集项目id	                
 * @param {String} channel	        推送到指定频道 可以设定：1 人工精选 可以设置多个 使用,隔开                    
 * @param {String} order_id	        推送到指定频道的指定位置多个使用,隔开，可以不设置但如果设置必须要和频道设置个数相同，不设定则使用9999作为排序序号（如果指定位置已经存在则旧数据后移）                    
 * @param {String} show_time	      推送到2 限时抢购时候设定 限时抢购的时间 格式如：2018-12-17 16 （有设定2的时候使用YYYY-MM-DD HH）                        
 */
export function admin_items_catch_publish(data) {
  return post('admin_items_catch_publish', data)
}

/**
 * 管理员删除采集内容
 * @param {String} asid	            asid	                
 * @param {String} id	              采集项目id	                
 */
export function admin_items_catch_delete(data) {
  return post('admin_items_catch_delete', data)
}

/**
 * 管理员查看采集内容 
 * @param {String} asid	            asid	                
 * @param {String} id	              采集项目id	                
 */
export function admin_items_catch_info(data) {
  return post('admin_items_catch_info', data)
}

/**
 * 管理员修改采集内容  
 * @param {String}  asid	                          asid	                
 * @param {String}  id	                            采集项目id	  
 * @param {String}  item_name	                      商品名字（推广，短） 
 * @param {String}  cat_name	                      一级分类 
 * @param {String}  cat_leaf_name	                  叶子分类 
 * @param {String}  item_category_id	              归属分类 
 * @param {String}  pict_url	                      图 
 * @param {String}  item_fullname	                  完整名字 
 * @param {String}  item_discount_price	            原价 
 * @param {String}  shop_nick	                      店名 
 * @param {String}  coupon_start_time	              优惠券开始时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  coupon_end_time	                优惠券结束时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  coupon_info	                    优惠券面额信息 
 * @param {String}  coupon_remain_count	            优惠券剩余量 （请输入整数） 
 * @param {String}  coupon_total_count	            优惠券总量 （请输入整数） 
 * @param {String}  max_commission_rate	            最高佣金 
 * @param {String}  coupon_price	                  优惠券价值 
 * @param {String}  item_salenum	                  销量（30天） （请输入整数） 
 * @param {String}  coupon_condition	              优惠券使用条件 
 * @param {String}  item_price	                    实际价格 
 * @param {String}  coupon_id	                      activityId(优惠券ID) 也可以输入 优惠券地址 
 * @param {String}  seller_id	                      店家id 
 * @param {String}  item_brand	                    商品品牌（淘宝） 
 * @param {String}  item_brand_id	                  商品拍id（淘宝） 
 * @param {String}  hot	                            热门程度 （请输入整数） 
 * @param {String}  item_goodrate	                  好评情况（需要除以100，再成为%） （请输入整数） 
 * @param {String}  item_promise	                  购物保证 
 * @param {String}  item_has_videos	                包含视频 （0无 1 有请输入整数） 
 * @param {String}  item_seller_type	              卖家等级 
 * @param {String}  item_shop_certtext	            店铺等级 
 * @param {String}  item_freight_insurance	        是否运费险 （请输入整数） 
 * @param {String}  item_juhuasuan	                是否聚划算 （请输入整数） 
 * @param {String}  item_juhuasuan_starttime	      聚划算开始时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_juhuasuan_endtime	        聚划算结束时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_taoqiangou	                是否淘抢购 （请输入整数） 
 * @param {String}  item_taoqiangou_starttime	      淘抢购开始时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_taoqiangou_endtime	        淘抢购截止时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_ad	                        推广文案              
 */
export function admin_items_catch_edit(data) {
  return post('admin_items_catch_edit', data)
}

/**
 * 管理员修改已发布的内容  
 * @param {String}  asid	                          asid	                
 * @param {String}  id	                            采集项目id	  
 * @param {String}  item_name	                      商品名字（推广，短） 
 * @param {String}  cat_name	                      一级分类 
 * @param {String}  cat_leaf_name	                  叶子分类 
 * @param {String}  item_category_id	              归属分类 
 * @param {String}  pict_url	                      图 
 * @param {String}  item_fullname	                  完整名字 
 * @param {String}  item_discount_price	            原价 
 * @param {String}  shop_nick	                      店名 
 * @param {String}  coupon_start_time	              优惠券开始时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  coupon_end_time	                优惠券结束时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  coupon_info	                    优惠券面额信息 
 * @param {String}  coupon_remain_count	            优惠券剩余量 （请输入整数） 
 * @param {String}  coupon_total_count	            优惠券总量 （请输入整数） 
 * @param {String}  max_commission_rate	            最高佣金 
 * @param {String}  coupon_price	                  优惠券价值 
 * @param {String}  item_salenum	                  销量（30天） （请输入整数） 
 * @param {String}  coupon_condition	              优惠券使用条件 
 * @param {String}  item_price	                    实际价格 
 * @param {String}  coupon_id	                      activityId(优惠券ID) 也可以输入 优惠券地址 
 * @param {String}  seller_id	                      店家id 
 * @param {String}  item_brand	                    商品品牌（淘宝） 
 * @param {String}  item_brand_id	                  商品拍id（淘宝） 
 * @param {String}  hot	                            热门程度 （请输入整数） 
 * @param {String}  item_goodrate	                  好评情况（需要除以100，再成为%） （请输入整数） 
 * @param {String}  item_promise	                  购物保证 
 * @param {String}  item_has_videos	                包含视频 （0无 1 有请输入整数） 
 * @param {String}  item_seller_type	              卖家等级 
 * @param {String}  item_shop_certtext	            店铺等级 
 * @param {String}  item_freight_insurance	        是否运费险 （请输入整数） 
 * @param {String}  item_juhuasuan	                是否聚划算 （请输入整数） 
 * @param {String}  item_juhuasuan_starttime	      聚划算开始时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_juhuasuan_endtime	        聚划算结束时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_taoqiangou	                是否淘抢购 （请输入整数） 
 * @param {String}  item_taoqiangou_starttime	      淘抢购开始时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_taoqiangou_endtime	        淘抢购截止时间 （格式如: 2018-12-17 00:00:00） 
 * @param {String}  item_ad	                        推广文案              
 */
export function admin_items_edit(data) {
  return post('admin_items_edit', data, { clear: false })
}


/**
 * 管理员查看已发布的清单 
 * @param {String} asid                   asid                          
 * @param {String} item_salenum_from      销量起始区间                          
 * @param {String} item_salenum_to        销量终止区间                          
 * @param {String} item_iid               淘宝ID                      
 * @param {String} item_name              商品名称                      
 * @param {String} item_brand             商品品牌                      
 * @param {String} from                   来源: dataoke大淘客 smzdm什么值得买 baicaio 白菜哦 cqp 酷Q        
 * @param {String} order                  排序方式[add_time | item_salenum | max_commission_rate | hot][ASC | DESC] 比如 add_time ASC注意中间有个空格                    
 * @param {String} page                   页码                
 * @param {String} pagesize               分页大小  
 */
export function admin_items_list(data) {
  return post('admin_items_list', data)
}

/**
 * 管理员查看商品内容
 * @param {String} asid                   asid                          
 * @param {String} id                     项目id                
 */
export function admin_items_info(data) {
  return post('admin_items_info', data)
}

/**
 * 管理员删除(下架)已发布内容 
 * @param {String} asid                   asid                          
 * @param {String} id                     项目id                
 */
export function admin_items_delete(data) {
  return post('admin_items_delete', data)
}

/**
 * 管理员调整发布内容次序  (已发布列表置顶用)
 * @param {String} asid        asid 
 * @param {String} id          采集项目id	                                    
 * @param {String} channel     推送到指定频道 可以设定：1 人工精选        
 *     
 * @param {String} order_id	   推送到指定频道的指定位置多个使用,隔开，
 *                             可以不设置但如果设置必须要和频道设置个
 *                             数相同，不设定则使用9999作为排序序号
 *                            （如果指定位置已经存在则旧数据后移）          
 */
export function admin_items_reorder_publish(data) {
  return post('admin_items_reorder_publish', data)
}

/**
 * 商品添加之抓取 商品地址/淘口令/二合一地址 
 * @param {String} asid        asid 
 * @param {String} data        输入商品地址，优惠券地址，二合一地址，淘口令                            
 */
export function admin_items_add_catch(data) {
  return post('admin_items_add_catch', data)
}

/**
 * 商品添加
 * @param {String}  asid	                  asid	                          
 * @param {String}  catch_id               抓取id	                          
 * @param {String}  item_name              推广名字	                          
 * @param {String}  coupon_id              activityId(优惠券ID) 也可以输入 优惠券地址                          
 * @param {String}  pict_url_ad            营销图url                          
 * @param {String}  item_ad                推广文案                              
 */
export function admin_items_add_save(data) {
  return post('admin_items_add_save', data)
}


/**
 * 商品编辑文案历史记录 
 * @param {String}  item_id	               淘宝ID	                          
 */
export function admin_item_change_history(data) {
  return post('admin_item_change_history', data)
}


/**
 * 品库商品列表,搜索 
 * @param {String} tsid	                             tsid
 * @param {String} q	                               搜索词
 * @param {String} item_brand_id	                   品牌id 可以多选 ,隔开 or
 * @param {String} type	                             高级筛选 淘抢购 聚划算 天猫 金牌卖家 运费险 视频 抽纸单 可以多选 ,隔开 and
 * @param {String} category_id	                     分类id 可以多选 ,隔开 or
 * @param {String} price_begin	                     价格范围 开始
 * @param {String} price_end	                       价格范围 结束
 * @param {String} coupon_price_begin	               优惠券价值 开始
 * @param {String} max_commission_rate_begin	       佣金比例 开始
 * @param {String} item_salenum_begin	               销量 开始
 * @param {String} channel	                         频道 0 9块9频道 1 人工精选频道 2 主推榜单 10 9.9元以下 11 20元封顶 38销量排行（爆款） 39佣金排行，总支出佣金
 * @param {String} apply_tbk_member_id	             放单用户id
 * @param {String} order_type	                       排序方式 item_price|item_salenum|coupon_use_count|max_commission_rate ASC|DESC 比如 item_price ASC 默认是时间倒序
 * @param {String} page	                             页码
 * @param {String} pagesize	                         分页大小                         
 */
export function pingku_items_list(data) {
  return post('pingku_items_list', data)
}

/**
 * 通过品库id搜索商品
 * @param {String} id
 */
export function pingku_items_info(data) {
  return post('pingku_items_info', data)
}

/**
 * 品库商品列表,搜索 
 * @param {String} asid	                  asid
 * @param {String} id	                    采集项目id 支持多个id同时修改， ,隔开             
 * @param {String} channel	              指定频道 可以设定：1 人工精选 2主推榜单                         
 */
export function admin_items_unpublish(data) {
  return post('admin_items_unpublish', data)
}

/**
 * 管理员查看黑名单清单 
 */
export function admin_items_black_list(data) {
  return post('admin_items_black_list', data)
}

/**
 * 管理员查看黑名单清单 
 */
export function admin_items_black_list_delete(data) {
  return post('admin_items_black_list_delete', data)
}

/* 验证商品id */
export function cms_jd_items_list(data) {
  return post('cms_jd_items_list', data)
}
export function cms_ddk_items_list(data) {
  return post('cms_ddk_items_list', data)
}
export function cms_ddk_item_info(data) {
  return post('cms_ddk_item_info', data)
}
export function cms_jd_item_info(data) {
  return post('cms_jd_item_info', data)
}